import React from "react"
import { Container, Title, Body, More } from "./styled/view-all"
import { Container as MainContainer } from "../../containers"

export default function ViewAll({ children, ...rest }) {
  return (
    <Container {...rest}>
      <MainContainer>{children}</MainContainer>
    </Container>
  )
}

ViewAll.Title = function ViewAllTitle({ children, ...rest }) {
  return <Title {...rest}>{children}</Title>
}

ViewAll.Body = function ViewAllBody({ children, ...rest }) {
  return <Body {...rest}>{children}</Body>
}

ViewAll.More = function ViewAllMore({ children, ...rest }) {
  return <More {...rest}>{children}</More>
}
